import Component from 'vue-class-component'
import IconButton from '@/components/buttons/richmenu/IconButton';

@Component({
  name: 'bold-button',
})
export default class BoldButton extends IconButton {
}
